
















import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import IspezioneDoc from "../ReportDoc/IspezioneDoc.vue"

@Component({
    components: {
        IspezioneDoc
    }
})
export default class ReportDocDialog extends Vue {
    @Prop() idDoc!:number;
    @Prop() dataDoc!:string;
    @Prop() tipoDoc!:string;
    @Prop() soggetto!: string;
    private dialog: boolean;

    constructor() {
        super();
        this.dialog = false
    }

    close() {
        this.dialog = false;
        bus.$emit("destroyIspezioneDialog");
    }

    created() {
        bus.$on("closeActivityDialog", () => {
            this.close();
        });
    }
}
